
import TextareaAutosize from 'react-textarea-autosize';
import { profileData } from "../../constants/profile";
export default function ProifleDetails({loading,data,handleChange,submit}){
    const divstyle="flex space-x-2";
    const pstyle="font-Roboto text-gray-600 font-medium tracking-wider text-sm";
    const inputTyle="border-2 border-gray-500 p-1 rounded-md";
    
    return (
        <div className="flex space-x-2" >
           <div className="space-y-6">
            
            {
                profileData.filter(el=>el.value!=="password").map((el)=><p className={pstyle} key={el.value}>{el.label}</p>)
            }
           </div>
           <div className="flex flex-col space-y-1">
           
           {
            profileData.filter(el=>el.value!=="password").map((el)=>{
                if(el.type==='textarea')
                return <TextareaAutosize
                minRows={3}
                maxRows={6}
               value={data[el.value]||''}
               onChange={(e)=>handleChange(el.value,e.target.value)}
               key={el.value}
                className='border-2 border-gray-500 rounded-md'
                />
                else
                return  <input type={el.type} key={el.value} className={inputTyle} value={data[el.value]||''} onChange={(e)=>handleChange(el.value,e.target.value)}/>
            })
           }
            <button className="bg-indigo-500 shadow-lg shadow-indigo-500/50 p-1 rounded-md font-Roboto font-bold text-white"
            disabled={loading}
            onClick={submit}
            >submit details</button>
           </div>
        </div>
    )
}